export default "__VITE_ASSET__D4IG6$Gl__"